export const LINGUIST_ONBOARDING_SEEN_KEY = "ce_portal.linguistOnboardingSeen";
export const LINGUIST_ONBOARDING_RESTART_EVENT = "linguist-onboarding-restart";

// Fail-open: if storage is unavailable (rare private-mode cases), treat as
// seen -> no nagging tour, and the notification flow behaves exactly like today.
export const hasSeenLinguistOnboarding = () => {
  try {
    return window.localStorage.getItem(LINGUIST_ONBOARDING_SEEN_KEY) !== null;
  } catch (error) {
    return true;
  }
};

export const markLinguistOnboardingSeen = () => {
  try {
    window.localStorage.setItem(LINGUIST_ONBOARDING_SEEN_KEY, "1");
  } catch (error) {
    // ignore
  }
};
